import Cookies from 'js-cookie'

const TokenKey = 'sanxiang_token'
const UserKey = 'sanxiang_user'

// Token 操作
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 7 }) // 7天过期
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

// 用户信息操作
export function getUserInfo() {
  const userStr = localStorage.getItem(UserKey)
  return userStr ? JSON.parse(userStr) : null
}

export function setUserInfo(userInfo) {
  return localStorage.setItem(UserKey, JSON.stringify(userInfo))
}

export function removeUserInfo() {
  return localStorage.removeItem(UserKey)
}

// 清除所有认证信息
export function clearAuth() {
  removeToken()
  removeUserInfo()
}

// 检查是否登录
export function isLoggedIn() {
  return !!getToken()
}

// 检查用户类型
export function hasUserType(userType) {
  const userInfo = getUserInfo()
  return userInfo && userInfo.userType === userType
}

// 检查是否是企业用户
export function isCompanyUser() {
  return hasUserType(1)
}

// 检查是否是公众用户
export function isPublicUser() {
  return hasUserType(2)
}

// 检查是否是运营用户
export function isAdminUser() {
  return hasUserType(3)
}